import { forwardRef } from 'react';
import NumberFormat from 'react-number-format';
import { getFormatSeparatorsOptions } from 'config/marketConfig';

const NumberFormatCustom = forwardRef(function NumberFormatCustom(props, ref) {
  const {
    onChange,
    name,
    min = 0,
    max = 1000000,
    decimalSeparator = false,
    fixedDecimalScale = false,
    allowNegative = false,
    decimalScale = 2,
    enableSuffix = false,
    ...other
  } = props;

  const separators = getFormatSeparatorsOptions();
  return (
    <NumberFormat
      {...other}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      isAllowed={({ formattedValue, floatValue }) =>
        formattedValue === '' || formattedValue === '-' || (floatValue >= min && floatValue <= max)
      }
      thousandSeparator={separators.thousandSeparator}
      decimalSeparator={decimalSeparator ? separators.decimalSeparator : false}
      allowNegative={allowNegative}
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      isNumericString
      getInputRef={ref}
      suffix={enableSuffix ? '%' : ''}
    />
  );
});

export default NumberFormatCustom;
